import { API } from '../api/constants';

export const COMPANY = 'company';

// СОТРУДНИКИ
export const EMPLOYEES = 'employees';

// ИСПОЛНИТЕЛЬСТВО
export const EXECUTORSHIP = 'executorship';
export const REQUEST_CARD = 'executorship/request/:id';

export const OFFER = 'executorship/offer';
export const OFFER_CREATE = 'offer_create';

export const ORDER = 'executorship/order';
export const ORDER_CREATE = 'executorship/order/add';
export const ORDER_CREATE_WITHOUT_FREIGHT = 'executorship/order/add_no_freight';

// ПАНЕЛЬ УПРАВЛЕНИЯ
export const CONTROL_PANEL = 'control-panel';

// ТЕХНИЧЕСКИЕ СРЕДСТВА
export const VEHICLES = 'vehicles';
export const ADD_VEHICLE = 'add_vehicle';
export const VEHICLE_CARD = 'vehicle_card/:id';

// ДОКУМЕНТЫ
export const DOCUMENTS = 'documents';
export const DOCUMENT_CARD = 'documents/documents_card/:id';
export const DOCUMENT_BY_ORDERS = 'documents/documents_by_orders';

// Таблица заказчиков
export const CUSTOMERS = 'customers';
// Добавление заказчиков
export const ADD_CUSTOMER = 'customers/add';
// Редактирование заказчика
export const EDIT_CUSTOMER = 'edit_customer/:id';
// карточка заказчика
export const CUSTOMER_CARD = 'customer_card/:id';

// АВТОРИЗАЦИЯ и РЕГИСТРАЦИЯ
export const AUTHORIZATION = 'authorization';
export const ADD_COMPANY = 'company';
export const LOGIN = 'login';
export const CHECK_CODE = 'check_code';
export const PROFILES_LIST = 'profiles';
export const ADD_PROFILE = 'add/profile';

export const DADATA_SUGGEST_GET = `${API}/utility/dadata/company_data/suggest/`;
// 'http://teleportos.com/api/dadata/suggest/org/';

export const EDIT_PROFILE = 'edit/profile';

// ФИНАНСЫ

export const FINANCES = 'finances';

// НАСТРОЙКИ СИСТЕМ

export const SYSTEM_SETTINGS = 'system_settings';

export const ADD_PERFORMER = 'system_settings/add_performer';

// ШАБЛОНЫ
export const TEMPLATES = 'templates';

// СОЗДАНИЕ ШАБЛОНА
export const ADD_TEMPLATE = 'templates/add';

export const TEMPLATE_CARD = 'templates/template';

// ФАЙЛЫ
export const UPLOAD_FILES = `files/upload`;

// ФОТОГРАФИИ НА СЕРВЕРЕ (USER)
export const IMAGE_SERVER = API.replace(/api$/, '');

// company_type_id (для добавления лицензиата) (по умолчанию company_type_id = carrier - Перевозчик)
export const COMPANY_TYPE_KEY = 'carrier';

export const ORDER_DOCUMENTS = 'order/:id(\\d+)/documents';
